import { useT } from "@/i18n";
import type { PersonNameValue } from "@/lib/person-name";

export function PersonNameFields({
  value,
  onChange,
  hint,
}: {
  value: PersonNameValue;
  onChange: (next: PersonNameValue) => void;
  hint?: string | null;
}) {
  const { t } = useT();
  function set<K extends keyof PersonNameValue>(key: K, v: string) {
    onChange({ ...value, [key]: v });
  }
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {hint ? (
        <p className="sm:col-span-2 text-xs text-slate-500">
          {t("name.dian_hint")} <span className="font-medium text-slate-700">{hint}</span>
        </p>
      ) : null}
      <label className="block">
        <span className="label">{t("name.first")} *</span>
        <input
          className="input mt-1.5"
          value={value.firstName}
          onChange={(e) => set("firstName", e.target.value)}
          autoComplete="given-name"
          required
          maxLength={80}
        />
      </label>
      <label className="block">
        <span className="label">{t("name.second")}</span>
        <input
          className="input mt-1.5"
          value={value.secondName}
          onChange={(e) => set("secondName", e.target.value)}
          maxLength={80}
        />
      </label>
      <label className="block">
        <span className="label">{t("name.first_surname")} *</span>
        <input
          className="input mt-1.5"
          value={value.firstSurname}
          onChange={(e) => set("firstSurname", e.target.value)}
          autoComplete="family-name"
          required
          maxLength={80}
        />
      </label>
      <label className="block">
        <span className="label">{t("name.second_surname")}</span>
        <input
          className="input mt-1.5"
          value={value.secondSurname}
          onChange={(e) => set("secondSurname", e.target.value)}
          maxLength={80}
        />
      </label>
    </div>
  );
}
